<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <!-- <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row> -->
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Diagnosi" @click="onEdit(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Diagnosi" @click="onDelete(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"> </font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <botox-configurazione-diagnosi-edit-modal-component ref="BotoxConfigurazioneDiagnosiEditModalComponent"></botox-configurazione-diagnosi-edit-modal-component>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import BotoxConfigurazioneDiagnosiEditModalComponent from "./BotoxConfigurazioneDiagnosiEditModalComponent.vue";
export default {
    components: { BotoxConfigurazioneDiagnosiEditModalComponent },
    name: "BotoxConfigurazioneDiagnosiListComponent",
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            fields: [
                { label: "*", key: "index", thStyle: "width: 3rem" },
                { label: "Categoria", key: "codiceCategoria" },
                { label: "Diagnosi", key: "diagnosi" },
                { label: "Tipo Trattamento", key: "tipoTrattamento" },
                { label: "", key: "actions", thStyle: "width: 11rem" },
            ],
            pathResource: "/botoxdiagnosi",
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            let filtro = sessionStorage["filtroDiagnosi"] ? JSON.parse(sessionStorage["filtroDiagnosi"]) : { page: me.currentPage, forPage: me.perPage };
            filtro.page = me.currentPage;
            filtro.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.log("Errore nel caricamento dei dati", error);
        },
        onEdit(item) {
            let me = this;
            me.$refs.BotoxConfigurazioneDiagnosiEditModalComponent.init(item);
        },
        onDelete(item) {
            let me = this;
            let message = "Sei sicuro di voler prosegure?";
            me.$bvModal
                .msgBoxConfirm(message, {
                    title: "Conferma eliminazione",
                    size: "md",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Sì",
                    cancelTitle: "No",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((confirmed) => {
                    if (confirmed) {
                        UtilityMixin.methods.deleteResource(me.pathResource + "/" + item.id, me.loadDeleteSuccess, me.loadDeleteError);
                    }
                })
                .catch((error) => {
                    console.log("Conferma cancellazione annullata", error);
                });
        },
        loadDeleteSuccess() {
            let me = this;
            me.loadData();
        },
        loadDeleteError(error) {
            console.log("Errore nella cancellazione del record", error);
        },
    },
};
</script>
